import { format } from "date-fns";
import { es } from "date-fns/locale";

export const getMonthsByDayIndex = (days: Date[]) => {
  const months: { name: string; days: number; startIndex: number }[] = [];

  let currentMonth = "";
  let dayCount = 0;
  let startIndex = 0;

  days.forEach((day, index) => {
    const monthFull = format(day, "MMMM 'de' yyyy", { locale: es });
    if (monthFull !== currentMonth) {
      if (currentMonth) {
        months.push({ name: currentMonth, days: dayCount, startIndex });
      }
      currentMonth = monthFull;
      dayCount = 1;
      startIndex = index;
    } else {
      dayCount++;
    }
  });

  if (currentMonth) {
    months.push({ name: currentMonth, days: dayCount, startIndex });
  }

  return months;
};
